import {PayPalScriptProvider, PayPalButtons} from "@paypal/react-paypal-js";
import {useAlert, useAuth} from "../../context";
import {config, endpoints} from "../../utils2";
import React from "react";


export function PaypalWrapper({basket, country, onSuccess}) {
    const {token} = useAuth()
    const {error} = useAlert()

    const initialOptions = {
        "client-id": config.get_paypal_client_id(),
        "enable-funding": "venmo",
        "disable-funding": "",
        "buyer-country": country, //Remove in LIVE mode
        currency: "EUR",
        "data-page-type": "product-details",
        components: "buttons",
        "data-sdk-integration-source": "developer-studio",
    };

    function createOrder() {
        return fetch(endpoints.paypal.create(), {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token.jwt}`
            },
            body: JSON.stringify({bsk_token: basket.bsk_token}),
        }).then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json()
        }).then(data => {
                const orderData = JSON.parse(data.data);

                if (orderData.id) {
                    return orderData.id
                } else {
                    throw new Error("No order ID received from PayPal.");
                }
            }
        ).catch(err => {
            console.error("Create Orders Error:", err);
            error(`Could not initiate PayPal Checkout... ${err.message}`);
            return null; // Ensure PayPal doesn't break due to a missing order ID
        })
    }

    function approveOrder(data, actions) {
        return fetch(endpoints.paypal.capture(data.orderID),
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token.jwt}`
                },
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json()
            })
            .then(data => {
                const orderData = JSON.parse(data.data);

                // Three cases to handle:
                //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                //   (2) Other non-recoverable errors -> Show a failure message
                //   (3) Successful transaction -> Show confirmation or thank you message
                const errorDetail = orderData?.details?.[0];

                if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
                    // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                    // recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
                    return actions.restart();
                } else if (errorDetail) {
                    // (2) Other non-recoverable errors -> Show a failure message
                    throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
                } else {
                    // (3) Successful transaction -> Show confirmation or thank you message
                    const transactionIdTemp = orderData.purchase_units[0].payments.captures[0].id;

                    // Call original Formik submit function to handle our transaction
                    // onSuccess(transactionId)
                    onSuccess(transactionIdTemp)
                }
            })
            .catch(err => {
                console.error(err);
                error(`Sorry, your transaction could not be processed...${err}`)
            })
    }

    return (
        <div className="Paypal">
            <PayPalScriptProvider options={initialOptions}>
                <PayPalButtons
                    style={{shape: "rect", layout: "vertical", color: "gold", label: "paypal"}}
                    createOrder={createOrder}
                    onApprove={approveOrder}
                />
                {/*<Button variant="success" onClick={() => {*/}
                {/*    onSuccess("pippo")*/}
                {/*}}>Set Pippo</Button>*/}
            </PayPalScriptProvider>
        </div>
    );
}